import _ from "lodash";

import client from "lib/apolloClient/client";
import { setToastMsg, getUserInfo } from "Login/modules/LoginModule";

import { bulkUploadByFileMutation } from "./ToolingMutations";

export const bulkUploadByFile = ({ url, type, inputs }) => {
  return async (dispatch, getState) => {
    try {
      const userInfo = getUserInfo();
      const response = await client.mutate({
        mutation: bulkUploadByFileMutation,
        variables: {
          url,
          type,
          inputs,
          organizationId: userInfo.org_id,
        },
      });
      const bulkUploadFileData = _.get(
        response,
        "data.platform.bulkUploadByFile",
        undefined
      );

      const responseSuccessful = _.get(bulkUploadFileData, "successful", false);

      let returnObject = {
        type: "success",
        msg: "toastMsgs:successfully_with_label",
        locale_params: [
          { key: "label", value: "toastMsgs:added", isPlainText: false },
        ],
      };
      if (!responseSuccessful) {
        returnObject = "toastMsgs:couldnt_be_added";
      }

      dispatch(setToastMsg(returnObject));

      return bulkUploadFileData;
    } catch {
      dispatch(setToastMsg("toastMsgs:something_went_wrong"));
      return {
        successful: false,
        errorsJSON: ["Something went wrong"],
      };
    }
  };
};
